import PermissionGate from "./PermissionGate";


function CadastrarPerfilFormulario({ salvarPerfilModal, alterarPerfilModal, removerPerfilModal, modoEdicao }) {
    return (
        <div className="modal-buttons">
            {!modoEdicao ? (
                <PermissionGate permissions={["cadastrarPerfil"]}>
                    <button onClick={salvarPerfilModal} className='modal-button modal-button-primary'>
                        Cadastrar
                    </button>
                </PermissionGate>
            ) : (
                <div className="modal-actions">
                    <PermissionGate permissions={["cadastrarPerfil"]}>
                        <button onClick={alterarPerfilModal} className='modal-button modal-button-warning'>
                            Alterar
                        </button>
                    </PermissionGate>

                    <PermissionGate permissions={["cadastrarPerfil"]}>
                        <button onClick={removerPerfilModal} className='modal-button modal-button-danger'>
                            Remover
                        </button>
                    </PermissionGate>
                </div>
            )}
        </div>
    );
}

export default CadastrarPerfilFormulario;